import { GatewayCapacitePro } from "@conformite/gateway";
import { isMulti, Button, FormAction } from "@endya-conformite/ui-kit";
import ChevronLeftIcon from "@endya-conformite/ui-kit/src/assets/icons/chevron-left.svg?react";
import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import SaveIcon from "@endya-conformite/ui-kit/src/assets/icons/save.svg?react";
import { GatewayCapaciteProApi } from "@src/api/conformite/capacitePro.api";
import {
  AssujettiParcoursConformiteEnum,
  ConformiteStepComponentProps,
  useChangeStepConformite,
} from "../../../AssujettiParcoursConformite";
import {
  ComponentWithFormData,
  WithFormData,
} from "../../../Components/ComponentWithFormData";
import { FormParcoursConformite } from "../../../Components/FormParcoursConformite";
import styles from "./ConformiteFormCapaciteProIOBSP.module.scss";
import {
  ConformiteFormCapaciteProIOBSPContent,
  useCapaciteProIOBSP,
} from "./ConformiteFormCapaciteProIOBSPContent";

export function ConformiteFormCapaciteProIOBSPWithData({
  data,
  formData,
  setFormData,
  changeStep,
  closePane,
  entreprise,
  readonly,
}: WithFormData<
  ConformiteStepComponentProps,
  GatewayCapacitePro.CapaciteProfessionnelleIOBSP
>) {
  const isMonoActivite = entreprise
    ? !isMulti([
        ...entreprise.categoriesActivites,
        ...entreprise.categoriesActivitesAccessoires,
      ])
    : false;
  const { goNext, goPrev } = useChangeStepConformite(
    AssujettiParcoursConformiteEnum.CAPACITE_PRO_IOBSP,
    changeStep,
    closePane,
    entreprise
  );
  const {
    typeJustificatifOptions,
    conditionCapaciteProfessionnelleValue,
    formConfig,
    onSubmit,
  } = useCapaciteProIOBSP(data, formData, isMonoActivite, setFormData);
  return (
    <FormParcoursConformite
      readonly={readonly}
      validateOnMount={formData !== null}
      renderActions={(submitAnyway, isSubmitting) => (
        <FormAction className={styles.actions}>
          <Button
            variant="text"
            onClick={() => {
              submitAnyway()
                .catch((error) => {
                  console.error(
                    "Error submitting form before going to previous step",
                    error
                  );
                })
                .finally(goPrev);
            }}
            type="button"
            iconVariant="left"
            icon={<ChevronLeftIcon />}
            disabled={isSubmitting}
          >
            Précédent
          </Button>
          <div className={styles.actionsRight}>
            <Button
              variant="text"
              onClick={() => {
                submitAnyway()
                  .catch((error) => {
                    console.error(
                      "Error submitting form before closing",
                      error
                    );
                  })
                  .finally(closePane);
              }}
              type="button"
              iconVariant="left"
              icon={isSubmitting ? <Loader /> : <SaveIcon />}
              disabled={isSubmitting}
            >
              {readonly ? "Fermer" : "Sauvegarder et fermer"}
            </Button>
            <Button
              type="button"
              onClick={() => {
                submitAnyway()
                  .catch((error) => {
                    console.error(
                      "Error submitting form before going to next step",
                      error
                    );
                  })
                  .finally(goNext);
              }}
              disabled={isSubmitting}
            >
              Suivant
            </Button>
          </div>
        </FormAction>
      )}
      formConfig={formConfig}
      onSubmit={onSubmit}
    >
      <ConformiteFormCapaciteProIOBSPContent
        data={data}
        conditionCapaciteProfessionnelleValue={
          conditionCapaciteProfessionnelleValue
        }
        typeJustificatifOptions={typeJustificatifOptions}
        formConfig={formConfig}
        isMonoActivite={isMonoActivite}
      />
    </FormParcoursConformite>
  );
}

export function ConformiteFormCapaciteProIOBSP({
  data,
  ...otherProps
}: ConformiteStepComponentProps) {
  return (
    <ComponentWithFormData
      FormComponent={ConformiteFormCapaciteProIOBSPWithData}
      formProps={{ data, ...otherProps }}
      fetchData={async () =>
        GatewayCapaciteProApi.getIOBSP(
          data.assujetti.id,
          data.assujetti.millesime
        )
      }
    />
  );
}
